import { FC } from 'react'
import { CompanyHistory } from './CompanyHistory'
import { MyHistory } from './MyHistory'
import { Trades } from './Trades'
import { AllocateFunds } from './AllocateFunds'
import { Introducer } from './Introducer'
import { TradingBalance } from './TradingBalance'
import { Settlement } from './Settlement'
import { IDataList } from './TreasurySections/FundAccountPopup/GenerateWallets/GenerateWalletsTableLists'

interface ComponentProps {
  data?: IDataList
  userId?: string | undefined
  loading?: boolean
  loadData?: (value: string | number) => void
}

export interface ITabList {
  tabLabel: string
  component: FC<ComponentProps>
}

export const tabListDefault: ITabList[] = [
  {
    tabLabel: 'Company History',
    component: CompanyHistory,
  },
  {
    tabLabel: 'My History',
    component: MyHistory,
  },
  {
    tabLabel: 'Allocate Funds',
    component: AllocateFunds,
  },
]

export const tabListAdmin: ITabList[] = [
  {
    tabLabel: 'Company History',
    component: CompanyHistory,
  },
  {
    tabLabel: 'My History',
    component: MyHistory,
  },
  {
    tabLabel: 'Allocate Funds',
    component: AllocateFunds,
  },
  {
    tabLabel: 'Introducer',
    component: Introducer,
  },
]

export const tabListViewer: ITabList[] = [
  {
    tabLabel: 'Company History',
    component: CompanyHistory,
  },
]

export const tabListSoleTrader: ITabList[] = [
  {
    tabLabel: 'My History',
    component: MyHistory,
  },
  {
    tabLabel: 'Trading Balance',
    component: TradingBalance,
  },
  {
    tabLabel: 'Trades',
    component: Trades,
  },
  {
    tabLabel: 'Settlement',
    component: Settlement,
  },
  {
    tabLabel: 'Introducer',
    component: Introducer,
  },
]

export const tabListExecutor: ITabList[] = [
  {
    tabLabel: 'My History',
    component: CompanyHistory,
  },
]
